import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=73a80f02&scoped=true"
import script from "./class-detail.vue?vue&type=script&lang=js"
export * from "./class-detail.vue?vue&type=script&lang=js"
import style0 from "./class-detail.vue?vue&type=style&index=0&id=73a80f02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a80f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a80f02')) {
      api.createRecord('73a80f02', component.options)
    } else {
      api.reload('73a80f02', component.options)
    }
    module.hot.accept("./class-detail.vue?vue&type=template&id=73a80f02&scoped=true", function () {
      api.rerender('73a80f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantClass/class-detail.vue"
export default component.exports